import { render, staticRenderFns } from "./SuppliersListFilters.vue?vue&type=template&id=422c4f05&"
import script from "./SuppliersListFilters.vue?vue&type=script&lang=js&"
export * from "./SuppliersListFilters.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersListFilters.vue?vue&type=style&index=0&id=422c4f05&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports